import { forwardRef, memo, useCallback } from "react";
import "react-datepicker/dist/react-datepicker.css";
import ReactDatePicker from "react-datepicker";
import { withTranslation } from "react-i18next";

const ReactDatePickerCommon = forwardRef(function DatePicker(
  {
    popperContainer,
    t,
    dateFormat,
    className,
    selected,
    onChange,
    minDate,
    popperPlacement,
    openToDate,
    maxDate,
    disabled,
    onSelect,
    open,
    onClickOutside,
    dropdownMode,
    onCalendarOpen,
    name,
    placeholderText,
  },
  ref,
) {
  const handleChange = useCallback(
    (date, event) => {
      if (!date) return;
      onChange?.(date, event);
    },
    [onChange],
  );

  // Today button only invokes onSelect; always forward to onChange as well.
  const handleSelect = useCallback(
    (date, event) => {
      if (!date) return;
      onSelect?.(date, event);
      onChange?.(date, event);
    },
    [onChange, onSelect],
  );

  return (
    <ReactDatePicker
      dateFormat={dateFormat}
      placeholderText={placeholderText}
      className={className}
      selected={selected}
      onChange={handleChange}
      onSelect={handleSelect}
      minDate={minDate}
      popperPlacement={popperPlacement}
      popperContainer={popperContainer}
      ref={ref}
      todayButton={t("today")}
      allowSameDay
      showMonthDropdown
      showYearDropdown
      scrollableYearDropdown
      yearDropdownItemNumber={100}
      openToDate={openToDate ?? selected}
      maxDate={maxDate}
      disabled={disabled}
      onKeyDown={(e) => e?.preventDefault()}
      open={open}
      onClickOutside={onClickOutside}
      dropdownMode={dropdownMode}
      onCalendarOpen={onCalendarOpen}
      name={name}
    />
  );
});
export default withTranslation()(memo(ReactDatePickerCommon));
